import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-assignment-date-picker',
  templateUrl: './assignment-date-picker.component.html',
  styleUrls: ['./assignment-date-picker.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class AssignmentDatePickerComponent implements OnInit {

  @Input() disabled: boolean;
  @Input() model: any;
  @Input() placeholder: string;
  @Input() isStartDate: boolean;
  @Input() otherDate: string;
  @Input() placement: string = "auto";
  showOtherMonthDays: string = "hidden";
  @Output() modelChange = new EventEmitter<any>();
  @ViewChild('datepickerInput', { static: false })
  datepickerInput: any;
  today: NgbDate;

  constructor() { }

  ngOnInit() {
    const todayObject = new Date();
    this.today = new NgbDate(todayObject.getFullYear(), todayObject.getMonth() + 1, todayObject.getDate());
  }

  modelChanged(val) {
    this.model = val;
    this.modelChange.emit(this.model);
  }

  markDisabledStartDate = (date: NgbDate): boolean => {
    if (date.before(this.today)) return true;

    const endDate = this.stringToNgbDate(this.otherDate);
    const endDateSelected = endDate !== null;

    if(endDateSelected && date.after(endDate)) return true;

    return false;
  }
  
  markDisabledEndDate = (date: NgbDate):boolean => {
    if (date.before(this.today)) return true;

    const startDate = this.stringToNgbDate(this.otherDate);
    const startDateSelected = startDate !== null;

    if(startDateSelected && date.before(startDate)) return true;

    return false;
  }

  stringToNgbDate(dateString: string): NgbDate {
    if(dateString === null) return null;
    var date = new Date(dateString)
    if(isNaN(date.getDate())) return null;
    return new NgbDate(date.getUTCFullYear(), date.getUTCMonth() + 1, date.getUTCDate());
  }
}
